import { DateFormat, formatDate } from "common";
import React from "react";
import { NoTranslate } from "../../Common/NoTranslate";

export interface DashboardCalendarRestrictedItemContentProps {
    title: string;
    start: Date;
    end: Date;
    allDay: boolean;
}

export const DashboardCalendarRestrictedItemContent = ({
    title,
    start,
    end,
    allDay,
}: DashboardCalendarRestrictedItemContentProps) => {
    const time = allDay ? null : [formatDate(start, DateFormat.TIME), formatDate(end, DateFormat.TIME)].join(" - ");

    return (
        <div className="h-full space-y-2 rounded bg-gray-lighter p-3 text-sm text-black">
            <div className="font-bold uppercase">Unavailable</div>

            {time ? (
                <NoTranslate as="div" className="text-gray-darker">
                    {time}
                </NoTranslate>
            ) : null}

            <NoTranslate as="div" className="line-clamp-2">
                {title}
            </NoTranslate>
        </div>
    );
};
